import React, {Component} from 'react'
import {
    DisplayBlockDiv,
    DisplayItemInput,
    DisplayItemInputLabel,
    DisplayItemInputTitle,
    DisplayItemSelect,
    DisplayItemSelectIcon,
} from '../../../../styledComponents/DisplayItem'
import {PrimaryStyledButton} from '../../../../styledComponents/Button'
import {Nullable} from '../../../../app/TypeHelpers'
import {NatGetCondominiumGroup} from '../../condominiumGroup/repository/NatGetCondominiumGroup'
import {StyledInput, StyledSelect} from '../../../../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import NatCondominiumGroupDataListComponent from '../../common/NatCondominiumGroupDataListComponent'
import {LOGIN_MODE} from '../../../../CodeMaster'

const KEY_LOGIN_MODE: string = 'loginMode'

interface Props {
    condominiumGroup: NatGetCondominiumGroup;
    subCondominiumGroup: NatGetCondominiumGroup;
    setSearchConditions: (condition: string) => void
}

interface States {
    condominiumCd: string
    condominiumGroupId: string
    condominiumName: string
}

export default class NatResidentCondominiumSelectFormComponent extends Component<Props, States> {
    constructor(props: Props) {
        super(props)

        this.state = {
            condominiumCd: '',
            condominiumGroupId: '',
            condominiumName: '',
        }

        this.handleInputChange = this.handleInputChange.bind(this)
        this.handleClickSearch = this.handleClickSearch.bind(this)
    }

    // 入力
    handleInputChange(event: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement>): void {
        let condominiumCd: string = this.state.condominiumCd
        let condominiumGroupId: string = this.state.condominiumGroupId
        let condominiumName: string = this.state.condominiumName

        // 入力項目
        switch (event.target.name) {
            case 'condominiumCd':
                condominiumCd = event.target.value
                break
            case 'condominiumGroupId':
                condominiumGroupId = event.target.value
                break
            case 'condominiumName':
                condominiumName = event.target.value
                break
        }

        this.setState({
            condominiumCd: condominiumCd,
            condominiumGroupId: condominiumGroupId,
            condominiumName: condominiumName,
        })
    }

    // 物件抽出
    handleClickSearch(): void {
        let searchConditions: string = ''

        // 検索条件生成
        if (this.state.condominiumCd) {
            searchConditions +=
                `condominiumCd=${encodeURIComponent(this.state.condominiumCd)}`
        }
        if (this.state.condominiumGroupId) {
            searchConditions +=
                `${(searchConditions === '') ? '' : '&'}condominiumGroupId=${encodeURIComponent(this.state.condominiumGroupId)}`
        }
        if (this.state.condominiumName) {
            searchConditions +=
                `${(searchConditions === '') ? '' : '&'}condominiumName=${encodeURIComponent(this.state.condominiumName)}`
        }
        this.props.setSearchConditions(searchConditions)
    }


    render(): Nullable<React.ReactElement> {
        if (window.sessionStorage.getItem(KEY_LOGIN_MODE) !== LOGIN_MODE.ADMIN.value) {
            return null
        }
        return (
            <div>
                <DisplayBlockDiv>
                    <DisplayItemInputLabel>
                        <DisplayItemInputTitle>物件コード</DisplayItemInputTitle>
                        <CondominiumCdInput
                            type="text"
                            name="condominiumCd"
                            maxLength={6}
                            defaultValue={this.state.condominiumCd}
                            onChange={this.handleInputChange}
                        />
                    </DisplayItemInputLabel>
                </DisplayBlockDiv>
                <DisplayBlockDiv>
                    <DisplayItemInputTitle>物件グループ</DisplayItemInputTitle>
                    <CondominiumGroupSelectIcon>
                        <CondominiumGroupSelect
                            name="condominiumGroupId"
                            defaultValue={this.state.condominiumGroupId}
                            onChange={this.handleInputChange}
                        >
                            <option value="">指定しない</option>
                            {this.props.condominiumGroup && this.props.condominiumGroup.details &&
                                <NatCondominiumGroupDataListComponent
                                    condominiumGroup={this.props.condominiumGroup.details}>
                                </NatCondominiumGroupDataListComponent>
                            }
                            {this.props.subCondominiumGroup && this.props.subCondominiumGroup.details &&
                                <NatCondominiumGroupDataListComponent
                                    condominiumGroup={this.props.subCondominiumGroup.details}>
                                </NatCondominiumGroupDataListComponent>
                            }
                        </CondominiumGroupSelect>
                    </CondominiumGroupSelectIcon>
                </DisplayBlockDiv>
                <DisplayBlockDiv>
                    <DisplayItemInputLabel>
                        <DisplayItemInputTitle>物件名</DisplayItemInputTitle>
                        <DisplayItemInput
                            type="text"
                            name="condominiumName"
                            maxLength={50}
                            defaultValue={this.state.condominiumName}
                            onChange={this.handleInputChange}
                        />
                    </DisplayItemInputLabel>
                </DisplayBlockDiv>
                <DisplayBlockDiv>
                    <PrimaryStyledButton onClick={this.handleClickSearch}>
                        物件抽出
                    </PrimaryStyledButton>
                </DisplayBlockDiv>
            </div>
        )
    }
}

// 物件コード
const CondominiumCdInput: StyledInput = styled(DisplayItemInput)`
    width: 30%
`
// 物件グループ
const CondominiumGroupSelect: StyledSelect = styled(DisplayItemSelect)`
    width: 50%
`
// 物件グループ（アイコン）
const CondominiumGroupSelectIcon = styled(DisplayItemSelectIcon)`
    &:after {
        right: 52%;
    }
`
